import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";

export const faqs = [
  {
    q: "What areas do you serve?",
    a: "We serve Harrisonburg and the surrounding Shenandoah Valley — including Elkton, Staunton, Bridgewater, Weyers Cave, Grottoes, Waynesboro, Penn Laird, Massanutten, Broadway, New Market, Dayton, and Verona. Not sure if you're covered? Just ask when you request your estimate.",
  },
  {
    q: "Do you offer free estimates?",
    a: "Yes. Every job starts with a free, no-pressure estimate so you know exactly what's included and what it costs before you commit to anything.",
  },
  {
    q: "What cleaning services do you provide?",
    a: "We handle residential, house, apartment, and commercial cleaning, plus deep cleaning, regular recurring service, move-in/move-out and turnover cleaning, office and janitorial work, window and carpet cleaning, post-construction cleanup, and Airbnb turnovers.",
  },
  {
    q: "Are your cleaners trained and trustworthy?",
    a: "Absolutely. Our crews are trained, background-checked, and respectful of your home or business. We treat every space as if it were our own.",
  },
  {
    q: "Do you bring your own supplies and equipment?",
    a: "Yes — our team arrives fully equipped with professional-grade supplies. If you prefer specific or eco-friendly products, just let us know and we'll accommodate.",
  },
  {
    q: "How does your referral reward work?",
    a: "For every two successful referrals you send our way, you earn a free regular cleaning service. It's our way of saying thank you for spreading the word.",
  },
  {
    q: "Can I schedule recurring cleanings?",
    a: "Definitely. We offer flexible weekly, biweekly, and monthly schedules, along with one-time cleans. We'll build a plan that fits your routine and your budget.",
  },
  {
    q: "What are your hours?",
    a: "We're available Monday through Friday from 7:00 AM to 7:00 PM, and Saturday and Sunday from 9:00 AM to 5:00 PM. Reach us anytime at (540) 560-4862.",
  },
];

const FAQSection = () => {
  return (
    <section className="section-padding bg-background">
      <div className="container-max max-w-3xl">
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-block text-primary text-sm font-bold uppercase tracking-widest mb-3"
          >
            FAQ
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground mb-4 tracking-tight font-bold"
          >
            Frequently Asked <span className="text-gradient-primary">Questions</span>
          </motion.h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 15 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05, duration: 0.4 }}
            >
              <AccordionItem
                value={`faq-${i}`}
                className="bg-card rounded-xl border border-border px-6 data-[state=open]:shadow-md data-[state=open]:border-primary/20 transition-all"
              >
                <AccordionTrigger className="font-heading text-lg tracking-tight text-foreground hover:no-underline py-5 text-left font-semibold">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm leading-relaxed pb-5 text-left">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            </motion.div>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
